import React from 'react';
import styles from './Elevator.scss';
import { bool, node, string } from 'prop-types';
import classNames from 'classnames';

export default function Elevator({ primary, secondary, isSecondaryVisible, className }) {
  return (
    <div className={classNames([styles.wrapper, className])}>
      <div className={styles.primary}>{primary}</div>
      <div className={classNames([styles.secondary, isSecondaryVisible && styles.secondaryVisible])}>{secondary}</div>
    </div>
  );
}

Elevator.displayName = 'Elevator';
Elevator.propTypes = {
  className: string,
  primary: node,
  secondary: node,
  isSecondaryVisible: bool,
};
